import { RouteObject } from 'react-router';
import { lazy } from 'react';

import { AppModule, Routes } from 'utils/constants';
import Loadable from 'components/loading/Loadable';
import MainLayout from 'components/layout/MainLayout/MainLayout';

const MarketImbalanceReports = Loadable(
  lazy(() => import('views/modules/Reporting/MarketImbalanceReports'))
);

const BalancingGroupReports = Loadable(
  lazy(() => import('views/modules/Reporting/BalancingGroupReports'))
);

const DeviceProductionPlanReports = Loadable(
  lazy(() => import('views/modules/Reporting/DeviceProductionPlanReports'))
);

const DeliveryPointProductionPlanReports = Loadable(
  lazy(
    () => import('views/modules/Reporting/DeliveryPointProductionPlanReports')
  )
);

const EconomicBenefitReports = Loadable(
  lazy(
    () =>
      import(
        'views/modules/Reporting/EconomicBenefitReports/EconomicBenefitReports'
      )
  )
);

export const routesReporting: RouteObject = {
  path: `${Routes.BASE_PATH}:tenant`,
  element: <MainLayout module={AppModule.REPORTING} />,
  children: [
    {
      path: Routes.REPORTING.MARKET_IMBALANCE,
      element: <MarketImbalanceReports />
    },
    {
      path: Routes.REPORTING.BALANCING_GROUP,
      element: <BalancingGroupReports />
    },
    {
      path: Routes.REPORTING.DEVICE_PRODUCTION_PLAN,
      element: <DeviceProductionPlanReports />
    },
    {
      path: Routes.REPORTING.DELIVERY_POINT_PRODUCTION_PLAN,
      element: <DeliveryPointProductionPlanReports />
    },
    {
      path: Routes.REPORTING.ECONOMIC_BENEFITS,
      element: <EconomicBenefitReports />
    }
  ]
};
